import { Box, Stack, Typography, Container } from '@mui/material';
import { observer } from 'mobx-react-lite';
import TelephoneInput from 'components/TelephoneInput';
import { useTranslation } from 'hooks/useTranslation';

export const TrackNumberSection = observer(() => {
    const { t, detect } = useTranslation();

    return (
        <Box
            sx={{
                overflow: 'hidden',
                height: { xs: detect.isEnglishLanguage ? '470px' : '550px', lg: detect.isEnglishLanguage ? '400px' : '480px' },
            }}
        >
            <Container
                sx={{
                    position: 'relative',
                    '&.MuiContainer-root': {
                        px: { xs: '0', md: '40px' },
                    },
                }}
            >
                <Stack direction="row" sx={{ zIndex: 1 }}>
                    <Stack
                        direction={'column'}
                        justifyContent={'center'}
                        alignItems={{
                            xs: 'center',
                            md: 'flex-start',
                        }}
                        sx={{ width: '100%', mt: '110px', zIndex: 1 }}
                    >
                        <Box sx={{ width: { xs: '350px', md: '650px' } }}>
                            <Typography variant="h4" sx={{ fontSize: '38px', display: 'inline', fontWeight: 700, lineHeight: '47.5px' }}>
                                {t('TrackNumber p1')}{' '}
                            </Typography>
                            <Typography
                                sx={{
                                    fontSize: '38px',
                                    display: 'inline',
                                    fontWeight: 700,
                                    lineHeight: '47.5px',
                                    background: 'linear-gradient(125deg, #0A2693 0%, #01CFFE 23.96%, #F2D3CD 100%)',
                                    WebkitBackgroundClip: 'text',
                                    WebkitTextFillColor: 'transparent',
                                }}
                            >
                                {t('TrackNumber p2')}{' '}
                            </Typography>
                            <Typography sx={{ fontSize: '38px', display: 'inline', fontWeight: 700, lineHeight: '47.5px' }}>{t('TrackNumber p3')}</Typography>{' '}
                            <Typography sx={{ color: '#A3A5B0', fontSize: '20px', fontWeight: 300, mt: '20px', lineHeight: '25px' }}>
                                {t('TrackNumber label')}
                            </Typography>
                        </Box>

                        <Box sx={{ width: '350px' }}>
                            <TelephoneInput redirectPath="/search" disableClickEventSend />
                        </Box>
                    </Stack>
                </Stack>
            </Container>
            <Box
                sx={{
                    zIndex: 0,
                    position: 'relative',
                    mt: { xs: undefined, lmd: '-200px' },
                }}
            >
                <Box
                    sx={{
                        height: '165px',
                        width: '100%',
                        position: 'absolute',
                        left: 0,
                        bottom: 0,
                        background: 'linear-gradient(180deg, rgba(12, 15, 33, 0) 0%, #0C0F21 100%)',
                    }}
                />
            </Box>
        </Box>
    );
});
